import { SystemLogAreas } from 'generated/graphql-types';
import {
   EagerSelectState,
   createEagerSelectAdapter,
   createEagerSelectReducer,
} from '../../select/eager-select/eager-select-reducer';
import { SystemLogAreaOption } from '../system-logs-area-option.interface';
import { systemLogAreaOptionActions } from './system-logs-area-select-option.actions';

export const systemLogAreaOptionFeatureKey = 'systemLogAreaOptions';

export type SystemLogAreaOptionState = EagerSelectState<SystemLogAreaOption>;

const adapter = createEagerSelectAdapter<SystemLogAreaOptionState, SystemLogAreaOption>({
   featureKey: systemLogAreaOptionFeatureKey,
   selectId: (area: SystemLogAreaOption) => {
      return area.systemLogAreaId ?? '';
   },
});

export const systemLogAreaOptionSelectors = adapter.getSelectors(filterAreaNameOption);

const initialState = adapter.getInitialState();

export const systemLogAreaOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   systemLogAreaOptionActions.search,
   systemLogAreaOptionActions.searchReset,
   systemLogAreaOptionActions.loadFromApi,
   systemLogAreaOptionActions.loadFromApiSuccess,
   systemLogAreaOptionActions.loadFromApiFailure
);

export function filterAreaNameOption<T extends SystemLogAreaOption>(
   areas: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(SystemLogAreas)
      .filter((name) => {
         if (searchText) {
            return name.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((name) => {
         return { name } as T;
      });

   return filteredOptions;
}
